import { useContext, useEffect, useState } from 'react';
import { MovableTypePrintingContext } from './MovableTypePrintingProvider';

interface GamePrintingPrintSampleResultProps {
  printResult: boolean,
}

export default function GamePrintingPrintSampleResult(props: GamePrintingPrintSampleResultProps) {
  const { theText, total } = useContext(MovableTypePrintingContext);
  const [squaresByColumn, setSquaresByColumn] = useState<null | Array<Array<null>>>(null);

  useEffect(() => {
    setSquaresByColumn(Array(2).fill(Array(Math.ceil(total / 2)).fill(null)));
  }, [total]);

  if (null === squaresByColumn) {
    return <></>;
  }

  return (
    <>
      <div className={`game-printing-printed game-printing-printed-sample game-printing-printed-sample-${props.printResult ? 'true' : 'false'} game-printing-printed-2-${Math.floor(total / 2)}`}>
        {/* {theText.split('').map(x => <div className="game-printing-printed-character">{x}</div>)} */}
        {squaresByColumn.map((squares, columnIndex) => <div key={columnIndex} className={`game-printing-printed-column`}>
          {squares.map((_, i) => <div key={i} className={`game-printing-printed-character ${theText[(1 - columnIndex) * Math.ceil(total / 2) + i].match(/^[\u0000-\u007f]*$/) ? 'en' : 'zh'}`}><div>{theText[(1 - columnIndex) * Math.ceil(total / 2) + i]}</div></div>)}
        </div>)}
        <div className="game-printing-printed-label">正確答案:</div>
      </div>
    </>
  )
};
